import { Show } from 'components/atoms';
import { ContentRow } from 'components/molecules';
import { Rechtstatsachen as RechtstatsachenUI } from 'components/profiles';
import React from 'react';
import { UnternehmenPlusDto } from 'types/unternehmen';
import { useTranslation } from 'utils/hooks';

interface RechtstatsachenProps 
{
  unternehmen: UnternehmenPlusDto;
}

const Rechtstatsachen: React.FC<RechtstatsachenProps> = (props) =>
{
  const { unternehmen } = props;
  const { t } = useTranslation('profiles');

  return (
    <>

      {/* Rechtstatsachen */}
      <Show when={unternehmen.rechtstatsachen.length > 0}>
        <ContentRow id="rechtstatsachen" title={t('profiles:unternehmen.rechtstatsachen.label')}>
          <p>{t('profiles:unternehmen.rechtstatsachen.description')}</p>
          <RechtstatsachenUI data={unternehmen.rechtstatsachen} />
        </ContentRow>
      </Show>

    </>
  );
};

export default Rechtstatsachen;
